import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { X, LogOut } from "lucide-react";

export const MobileMenu = ({ open, onClose, links, user, home, homeLabel, onLogout }) => {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);
  if (!open) return null;
  const item = "block py-4 text-2xl font-serif-lux border-b border-white/5 transition-colors";
  return (
    <div data-testid="mobile-menu" className="md:hidden fixed inset-0 z-[60] bg-[#0B0F19] flex flex-col px-6 pt-5 pb-8 overflow-y-auto">
      <div className="flex justify-end">
        <button data-testid="mobile-menu-close-btn" onClick={onClose} aria-label="Close menu" className="p-3 -mr-3 text-slate-300"><X className="w-6 h-6" /></button>
      </div>
      <nav className="mt-2" onClick={onClose}>
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} data-testid={`mobile-nav-${l.label.toLowerCase().replace(" ", "-")}`}
            className={({ isActive }) => `${item} ${isActive ? "text-[#38BDF8]" : "text-slate-100"}`}>{l.label}</NavLink>
        ))}
        {user?.role === "admin" && <NavLink to="/admin" data-testid="mobile-nav-admin" className={`${item} text-slate-100`}>Admin</NavLink>}
      </nav>
      <div className="mt-auto pt-8 space-y-3" onClick={onClose}>
        {user ? (
          <>
            <NavLink to={home} data-testid="mobile-nav-dashboard-btn" className="btn-gold w-full py-4 text-center block">{homeLabel}</NavLink>
            <button data-testid="mobile-nav-logout-btn" onClick={onLogout} className="btn-ghost w-full py-4 flex items-center justify-center gap-2"><LogOut className="w-4 h-4" />Log out</button>
          </>
        ) : (
          <>
            <NavLink to="/register" data-testid="mobile-nav-join-btn" className="btn-gold w-full py-4 text-center block">Join — $29/mo</NavLink>
            <NavLink to="/login" data-testid="mobile-nav-login-btn" className="btn-ghost w-full py-4 text-center block">Sign in</NavLink>
          </>
        )}
      </div>
    </div>
  );
};
